<template>
  <!-- 輔導評價頁 -->
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px">
    <v-card>
      <v-card-title>
        <span class="title ml-3">輔導評價</span>
      </v-card-title>

      <v-card-text ref="cardText" class="card-text">
        <v-form ref="form" v-model="valid">
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs5 class="avatar-box">
                <app-avatar :size="128" :id="teacherProfile.avatar" />
              </v-flex>

              <v-flex xs6 offset-xs1>
                <div class="title">{{teacherName}} {{teacherDegree}}</div>
                <div class="title mt-3">評等: <app-rating :value="teacherProfile.rating || 0" /></div>
                <div class="title mt-3">年資: {{teachingYears}}</div>
                <div class="title mt-3 text-overflow-hidden">科目: {{teacherSubjects}}</div>
              </v-flex>

              <v-flex class="mt-4" xs12>
                <app-rating-field v-model="rating" label="給老師的評價" />
              </v-flex>

              <v-flex ref="errMsg">
                <v-alert
                  v-show="errMsg"
                  transition="slide-y-transition"
                  :value="true"
                  type="error">
                  {{errMsg}}
                </v-alert>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          color="primary"
          @click="submit"
          flat>
          送出
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {scrollTo} from '@/lib/utils';

export default {
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      loadingKnowledge: false,
      errMsg: null,

      fudaoId: null,
      studentId: null,
      teacherProfile: {},

      rating: 0
    };
  },

  computed: {
    ...mapState({
      subjects: state => state.subjects
    }),

    teacherName() {
      return this.teacherProfile.nickname || this.teacherProfile.username;
    },

    teacherDegree() {
      if (!this.teacherProfile.metadata) {
        return '';
      }
      return this.teacherProfile.metadata['學歷'];
    },

    teachingYears() {
      if (!this.teacherProfile.metadata) {
        return '';
      }
      return this.teacherProfile.metadata['年資'];
    },

    teacherSubjects() {
      if (!this.teacherProfile.metadata) {
        return '';
      }
      let teacherSubjects = this.teacherProfile.metadata['科目'] || [];
      teacherSubjects = teacherSubjects.map(id => {
        return this.subjects[id] ? this.subjects[id].tname : '';
      });

      return teacherSubjects.join('/');
    }
  },

  watch: {
    dialog() {
      if (!this.dialog) {
        this.reset();
      }
    }
  },

  mounted() {
    this.$eventBus.$on('fudao-evaluation-teacher', this.open);
  },

  beforeDestroy() {
    this.$eventBus.$off('fudao-evaluation-teacher', this.open);
  },

  methods: {
    ...mapActions('fudao', {
      reportStudentForm: 'reportStudentForm',
      getProfileById: 'getProfileById'
    }),

    ...mapActions('alert', {
      addAlert: 'add'
    }),

    async open({fudaoId, teacherId, studentId}) {
      this.dialog = true;
      this.fudaoId = fudaoId;
      this.studentId = studentId;
      this.teacherProfile = await this.getProfileById(teacherId);
    },

    toggle() {
      this.dialog = !this.dialog;
    },

    async submit() {
      if (!this.$refs.form.validate()) {
        this.errMsg = '欄位輸入有誤';
        scrollTo(this.$refs.errMsg, this.$refs.cardText);
        return;
      }

      this.errMsg = null;
      this.loading = true;
      try {
        let studentForm = {
          rating: this.rating
        };
        await this.reportStudentForm({
          studentId: this.studentId,
          fudaoId: this.fudaoId,
          studentForm
        });
        this.$emit('submited');
      } catch (e) {
        this.addAlert({level: 'error', content: '評價發生錯誤'});
      } finally {
        this.loading = false;
        this.dialog = false;
      }
    },

    reset() {
      this.errMsg = null;
      this.$refs.form.reset();
    }
  }
};
</script>

<style lang="stylus" scoped>

.avatar-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.card-text {
  overflow: auto;
  max-height: 70vh;
}

.rating-label {
  font-size: 16px;
  color: rgba(0,0,0,.54);
}

.rating-stars {
  position: relative;
  left: -8px;
  margin-top: 4px;
}

.chip-select >>> .v-chip {
  background-color: $secondary-color;
}

.field-error {
  label {
    color: $error-color;
  }

  .error-message {
    display: block;
  }
}

.error-message {
  font-size: 12px;
  color: $error-color;
  display: none;
}
</style>
